var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',_vm._l((_vm.filenames),function(filename,index){return _c('figure',{key:index,style:(_vm.style(filename))},[_c('ImageLoader',{attrs:{"srcset":_vm.srcset(_vm.page.files[filename]),"sizes":_vm.sizes(filename)}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }